/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { useThemeObserver } from '@atlaskit/tokens';
import { AI_BORDER_PALETTE } from './constants';
import AIGlowingBorder from './ai-glowing-border';
import { popupContainerStyles } from '../../HoverCard/styled';
var contentStyles = css({
  transition: 'box-shadow 0.5s ease'
});
var contentStylesPrismVisible = css({
  // intentionally set opacity to 0 to remove the shadow with fade out animation
  boxShadow:
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
  '0px 8px 12px rgba(9, 30, 66, 0),0px 0px 1px rgba(9, 30, 66, 0)'
});
var AIPrism = function AIPrism(_ref) {
  var _AI_BORDER_PALETTE$co;
  var children = _ref.children,
    _ref$isGlowing = _ref.isGlowing,
    isGlowing = _ref$isGlowing === void 0 ? true : _ref$isGlowing,
    _ref$isMoving = _ref.isMoving,
    isMoving = _ref$isMoving === void 0 ? true : _ref$isMoving,
    isVisible = _ref.isVisible,
    testId = _ref.testId;
  var _useThemeObserver = useThemeObserver(),
    _useThemeObserver$col = _useThemeObserver.colorMode,
    colorMode = _useThemeObserver$col === void 0 ? 'light' : _useThemeObserver$col;
  return jsx(AIGlowingBorder, {
    additionalCss: {
      animatedSvgContainer: css({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 0.5s ease'
      })
    },
    palette: (_AI_BORDER_PALETTE$co = AI_BORDER_PALETTE[colorMode]) !== null && _AI_BORDER_PALETTE$co !== void 0 ? _AI_BORDER_PALETTE$co : AI_BORDER_PALETTE.light,
    isGlowing: isGlowing,
    isMoving: isMoving,
    testId: testId
  }, jsx("div", {
    css: [
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    popupContainerStyles, contentStyles, isVisible ? contentStylesPrismVisible : undefined]
  }, children));
};
export default AIPrism;